
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DateFormatMixin } from "@/mixins";
import { axiosProvider } from "@/store/provider";

interface MediaItem {
  id: number;
  techID: number;
  ext: string;
  filename: string;
  description: string;
  created_at: string;
  mime: string;
  blob: string;
}

interface MediaResponse {
  media: MediaItem[];
}

@Component
export class MRMedia extends mixins(DateFormatMixin) {
  @Prop([String, Number])
  readonly recordId!: string | number;

  private media: MediaItem[] = [];
  private loading = true;
  private lightboxVisible = false;
  private selectedMedia: MediaItem | null = null;

  async mounted() {
    await this.fetchMedia();
  }

  async fetchMedia() {
    try {
      this.loading = true;
      // console.log('MRMedia: Fetching media for MR ID:', this.recordId);
      
      // Use the correct base URL for the media API
      const response = await axiosProvider('mr').get<MediaResponse>(`mr/${this.recordId}/media`);
      
      // console.log('MRMedia: Raw API response:', response);
      // console.log('MRMedia: Response status:', response.status);
      // console.log('MRMedia: Response data:', response.data);
      // console.log('MRMedia: Media array:', response.data?.media);
      // console.log('MRMedia: Media array length:', response.data?.media?.length);
      
      if (response.data && response.data.media) {
        this.media = response.data.media;
        // console.log('MRMedia: Set media array with', this.media.length, 'items');
        if (this.media.length > 0) {
          // console.log('MRMedia: First media item:', this.media[0]);
        }
      } else {
        this.media = [];
        // console.log('MRMedia: No media found, set empty array');
      }
    } catch (error) {
      // console.error('MRMedia: Error fetching media:', error);
      // console.error('MRMedia: Error response:', error.response);
      this.media = [];
    } finally {
      this.loading = false;
      // console.log('MRMedia: Loading finished, media count:', this.media.length);
    }
  }

  getImageUrl(item: MediaItem): string {
    // If the API returns a blob, you might need to create a blob URL
    // For now, assuming the blob is a base64 string or direct URL
    if (item.blob) {
      // If blob is base64
      if (item.blob.startsWith('data:')) {
        return item.blob;
      }
      // If blob is just base64 data
      if (item.mime) {
        return `data:${item.mime};base64,${item.blob}`;
      }
    }
    
    // Fallback - you might need to adjust this based on your API structure
    return `data:image/${item.ext};base64,${item.blob}`;
  }

  openLightbox(item: MediaItem) {
    this.selectedMedia = item;
    this.lightboxVisible = true;
  }
}

export default MRMedia;
